import { forwardRef } from 'react'
import { IMaskInput } from 'react-imask'

type TCustomProps = {
  onChange: (event: { target: { value: string } }) => void
}
export const TextMaskPhone = forwardRef<HTMLInputElement, TCustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props

    return (
      <IMaskInput
        {...other}
        mask='+{7} (000) 000-00-00'
        definitions={{
          '#': /[1-9]/,
        }}
        placeholder='+7 (000) 000-00-00'
        prepare={(value: string) => {
          const digits = value.replace(/\D/g, '')
          if (
            digits.length === 11 &&
            (digits[0] === '7' || digits[0] === '8')
          ) {
            return digits.slice(1)
          }
          return value
        }}
        onAccept={(value: string) => {
          onChange({ target: { value } })
        }}
        inputRef={ref}
      />
    )
  },
)
